// eslint-disable-next-line import/no-extraneous-dependencies,import/no-unresolved
import { MissingEnvVariableException } from '@reward-platform/shared-api/exceptions/MissingEnvVariableException'
import { z } from 'zod'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Iata } from '@reward-platform/platform-config'

const partnersConfigSchema = z.object({
  IDENTITY_M2M_AUDIENCE: z.string().nonempty().url().default('https://api.iagloyalty.com/'),

  IDENTITY_M2M_EI_CLIENT_ID: z.string().nonempty(),
  IDENTITY_M2M_EI_CLIENT_SECRET: z.string().nonempty(),
  IDENTITY_M2M_EI_ISSUER: z.string().nonempty(),

  IDENTITY_M2M_BA_CLIENT_ID: z.string().nonempty(),
  IDENTITY_M2M_BA_CLIENT_SECRET: z.string().nonempty(),
  IDENTITY_M2M_BA_ISSUER: z.string().nonempty(),

  IDENTITY_M2M_IB_CLIENT_ID: z.string().nonempty(),
  IDENTITY_M2M_IB_CLIENT_SECRET: z.string().nonempty(),
  IDENTITY_M2M_IB_ISSUER: z.string().nonempty(),
})

let partnersConfigs: z.infer<typeof partnersConfigSchema> | undefined

function getConfigs() {
  if (!partnersConfigs) {
    partnersConfigs = partnersConfigSchema.parse(process.env)
  }
  return partnersConfigs
}

export function getPartnerConfig(opCo: Iata) {
  const configs = getConfigs()
  switch (opCo) {
    case 'BA': {
      return {
        issuerUrl: configs.IDENTITY_M2M_BA_ISSUER,
        clientId: configs.IDENTITY_M2M_BA_CLIENT_ID,
        clientSecret: configs.IDENTITY_M2M_BA_CLIENT_SECRET,
        audience: configs.IDENTITY_M2M_AUDIENCE,
      }
    }
    case 'EI': {
      return {
        issuerUrl: configs.IDENTITY_M2M_EI_ISSUER,
        clientId: configs.IDENTITY_M2M_EI_CLIENT_ID,
        clientSecret: configs.IDENTITY_M2M_EI_CLIENT_SECRET,
        audience: configs.IDENTITY_M2M_AUDIENCE,
      }
    }
    case 'IB': {
      return {
        issuerUrl: configs.IDENTITY_M2M_IB_ISSUER,
        clientId: configs.IDENTITY_M2M_IB_CLIENT_ID,
        clientSecret: configs.IDENTITY_M2M_IB_CLIENT_SECRET,
        audience: configs.IDENTITY_M2M_AUDIENCE,
      }
    }
    default: {
      throw new MissingEnvVariableException('Partner not supported')
    }
  }
}
